import React from "react";
import More from "../images/more.png";
import ShareuserIcons from "./ShareuserIcons";
import { newDateChanger } from "../Utils/CommonFunction";
import { TiDeleteOutline } from "react-icons/ti";
import { TbEdit } from "react-icons/tb";
import { LiaUserPlusSolid } from "react-icons/lia";
const Item = (props) => {
  return (
    <div
      className="folder-details-item"
      style={{
        maxWidth: props.title === "Note" ? "440px" : null,
        minWidth: props.title === "Note" ? "380px" : null,
      }}
    >
      <p>{props.title}</p>
      <p
        style={{
          fontWeight: 600,
          color: "#292C31",
        }}
      >
        {props.value}
      </p>
    </div>
  );
};
function FolderDetails({
  folderData,
  shareFolder,
  confirmtoggle,
  edittoggle,
}) {
  return (
    <div className="folder-details-container">
      <div
        style={{ display: "flex", alignItems: "center", gap: "15px" }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "30px",
          }}
        >
          {folderData?.folderId ? null : (
            <Item
              title={"Total Environment"}
              value={folderData?.totalEnvs}
            />
          )}

          <Item
            title={"Total Password"}
            value={
              folderData?.folderId
                ? folderData?.totalEnvPasswords
                : folderData?.totalFolderPasswords
            }
          />
          <Item
            title={"Created On"}
            value={newDateChanger(folderData?.createdAt)}
          />
          <Item title={"Created By"} value={folderData?.userName} />

          <div className="folder-details-item ">
            <p>Shared With</p>
            <p>
              <ShareuserIcons
                folderId={
                  folderData?.folderId
                    ? folderData?.folderId
                    : folderData?._id
                }
                envId={folderData?.folderId ? folderData?._id : ""}
                env_subfolder={folderData?.folderId ? true : false}
              />
            </p>
          </div>
          <Item title={"Note"} value={folderData?.description} />

          <div className=" folderDIcon">
            <LiaUserPlusSolid
              onClick={() => shareFolder(folderData)}
            />
          </div>
          <div className=" folderDIcon">
            <TbEdit onClick={() => edittoggle(folderData)} />
          </div>
          <div className=" folderDIcon">
            <TiDeleteOutline
              onClick={() => confirmtoggle(folderData)}
            />
          </div>
        </div>

        {/* <img
          src={More}
          alt="more option"
          style={{
            width: "18px",
            height: "18px",
            cursor: "pointer",
          }}
        /> */}
      </div>
    </div>
  );
}

export default FolderDetails;
